module.exports = __webpack_public_path__ + "img/public/SiteIcons/arrow-right-white-small.svg?8c008121";